import { all } from 'redux-saga/effects';
import {
  handleOnSetTourReferences,
  handleOnGetFromTourReference
} from '@state/tours/tour-references/tourReferencesOperations';

export default function* combinedBasketSagas() {
  yield all([handleOnSetTourReferences(), handleOnGetFromTourReference()]);
}
